export const prof = document.createElement("p");
prof.innerText = "Косметик";
